import { ApiRequestService } from 'services/ApiRequestService';

export const SystemMonitoringService = {
    getHealthChecks() {
        return ApiRequestService.get('system', 'HealthChecks');
    }
};
